import {
    GET_CHARGEBACK_STATUS_DEF,
    GET_CHARGEBACK_STATUS_DEF_SUCCESS,
    CHARGEBACK_STATUS_DEF_API_ERROR
} from "./actionTypes"

const INIT_STATE = {
    recordList: [], //model data ve error
    error: {},
    loading: false,
}

const chargebackStatusDef = (state = INIT_STATE, action) => {
    switch(action.type) {

        case GET_CHARGEBACK_STATUS_DEF:
            return {
                ...state,
                loading: true,
            }

        case GET_CHARGEBACK_STATUS_DEF_SUCCESS:
            return {
                ...state,
                recordList: action.payload,
                loading: false
            }

        case CHARGEBACK_STATUS_DEF_API_ERROR:
            return {
                ...state,
                error: action.payload,
                loading: false
            }

        default:
            return state
    }
}

export default chargebackStatusDef